import 'leaflet'
import baseMap from '@/app/geo/mixins/base-map'
import url from '@/utils/url'
import 'leaflet-html-legend/src/L.Control.HtmlLegend.css'
import 'leaflet-html-legend/src/L.Control.HtmlLegend.js'
import urlUtil from '@/utils/url'
import {
  MAP_GRID,
  MAP_MO,
} from '@/utils/map/superclaster/objectsSuperclasterUtils'
import { garbage } from '@/api/api-endpoints'

export default {
  data() {
    this.mapLayers = null
    this.legend = null
    return {
      clusterEnabled: false, // отключена кластеризация на карте
      layersLoading: false,
      layers: [],
      layersWithData: [],
      showedStatus: [],
      yearChanged: false,
      typesGarbage: [],
    }
  },
  mixins: [baseMap],
  computed: {
    status() {
      return this.showedStatus || []
    },
    showMapLegend: {
      get() {
        return this.$store.state.showMapLegend
      },
      set(value) {
        this.$store.commit('mapLegend', value)
      },
    },
    layersConf() {
      const rightMenu = this.getLayersConf()
      if (rightMenu.dump) {
        rightMenu.dump.hide = this.$store.getters.isGuest
      }
      return rightMenu
    },
  },
  created() {
    this.subsForm = this.$emitter.listen('form', (e) => this.onFormEvent(e))
    if (this.$isMobile()) {
      this.showMapLegend = false
    }
  },
  destroyed() {
    this.subsForm.unsubscribe()
    // clean saved layers data
    this.$store.commit('cleanCache')
  },
  methods: {
    toggleClusters() {
      this.map.eachLayer((l) => {
        if (l?.options?.pane === 'markerPane') {
          l.remove()
        }
      })
      this.mapLayers = this.objectsLayerDrawer.setLayersConfigAndDraw(
        this.layersConf
      )
      this.setDataToLayersFromStore()
    },
    async showStatus() {
      await this.replaceRoute({ status: this.status }, false)
    },
    async getGarbageTypes() {
      this.typesGarbage =
        (await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: garbage.garbageTypes(),
          })
        ).data.data) || []
    },
    getPreferCanvas() {
      return false
    },
    onLayersChange(item, name, rootGroupName) {
      if (item.hasOwnProperty('groups')) {
        let parentExist = this.layers.indexOf(name) > -1
        for (let groupItemName in item.groups) {
          // if parent check add all
          if (parentExist && this.layers.indexOf(groupItemName) === -1) {
            this.layers.push(groupItemName)
          }
          // uncheck all if parent unchecked
          if (!parentExist && this.layers.indexOf(groupItemName) > -1) {
            this.layers = this.layers.filter((v) => v !== groupItemName)
          }
        }
      } else {
        let itemExist = this.layers.indexOf(name) > -1
        if (!itemExist) {
          // uncheck parent
          this.layers = this.layers.filter((v) => v !== rootGroupName)
        } else {
          if (this.layersConf[rootGroupName]) {
            // check: all sub item of group checked
            let allChecked = true
            for (let groupItemName in this.layersConf[rootGroupName].groups) {
              if (this.layers.indexOf(groupItemName) === -1) {
                allChecked = false
              }
            }
            // remove root
            if (allChecked === false) {
              this.layers = this.layers.filter((v) => v !== rootGroupName)
            } else if (this.layers.indexOf(rootGroupName) === -1) {
              // add root if not exist
              this.layers.push(rootGroupName)
            }
          }
        }
      }
      this.$bar.start().set(12)
      this.layersLoading = true
      setTimeout(() => this.replaceRoute({ layers: this.layers }, false), 50)
      this.$bar.finish()
    },
    routeHandler() {
      this.setFiltersFromUrl()
      this.layersLoading = false
      this.setDataToLayersFromStore()
    },
    setFiltersFromUrl() {
      if (this.$route.query.layers) {
        let route = url.getRoute(this.$route)
        if (typeof route.query['layers'] === 'string') {
          this.layers = route.query['layers'].split(',')
        }
      }
      if (this.$route.query.status) {
        let route = url.getRoute(this.$route)
        if (typeof route.query['status'] === 'string') {
          this.showedStatus = route.query['status'].split(',')
        }
      }
    },
    getCopyWithoutObservers(data) {
      return JSON.parse(JSON.stringify(data))
    },
    //TODO вынести этот метод в маркер и вызывать у маркера
    getMarkerHash(marker) {
      if (marker && marker.options) {
        let id = marker.options.id || marker.id
        let lat = marker.options.model.lat || marker.options.model.latitude
        let lng = marker.options.model.lng || marker.options.model.longitude
        return `${id},${lat},${lng}`
      }
      return ``
    },
    getOpenedMarkerInfo() {
      let id, lat, lng, type
      if (this.$route.query.openedPopupInfo) {
        ;[id, lat, lng] = this.$route.query.openedPopupInfo.split(',')
      }
      return { id, lat, lng, type }
    },
    getParentsConf(layersArr, conf) {
      let parents = {}
      for (let key in conf) {
        if (layersArr.indexOf(key) > -1) {
          parents[key] = conf[key]
        }

        if (conf[key].hasOwnProperty('groups')) {
          for (let childKey in conf[key].groups) {
            if (layersArr.indexOf(childKey) > -1) {
              parents[key] = conf[key]
            }
          }
        }
      }
      return parents
    },
    getLayerEndpoint(conf, type, route) {
      if (conf[type] && conf[type].endpoint) {
        return conf[type].endpoint(route)
      }
      return null
    },
    updateEndpointForLegalAndIndividual(endpoint) {
      if (this.layers.includes('legal')) {
        endpoint += `&is_legal=1`
      }
      if (this.layers.includes('garbage_individual')) {
        endpoint += `&is_legal=0`
      }
      if (
        this.layers.includes('garbage_individual') &&
        this.layers.includes('legal')
      ) {
        endpoint = endpoint.replace('&is_legal=0', '')
        endpoint = endpoint.replace('&is_legal=1', '')
      }
      return endpoint
    },

    updateDataForLegalAndIndividual(data) {
      const result = []

      const legalTypes = this.typesGarbage.filter(
        ({ group }) => group?.code === 'legal'
      )
      const individualTypes = this.typesGarbage.filter(
        ({ group }) => group?.code === 'individual'
      )

      Object.values(data).forEach((v) => {
        v.forEach((el) => {
          if (el.garbage_source_type_id) {
            if (!result.some((item) => item.id === el.id)) {
              result.push(el)
            }
          }
        })
      })

      if (this.layers.includes('garbage_individual')) {
        data.garbage_individual = []
        individualTypes.forEach(({ id }) => {
          if (!data[id]) return
          data.garbage_individual[id] = []
          data.garbage_individual[id] = [...data[id]]
        })
      }
      if (this.layers.includes('legal')) {
        data.legal = []
        legalTypes.forEach(({ id }) => {
          if (!data[id]) return
          data.legal[id] = []
          data.legal[id] = [...data[id]]
        })
      }
      return data
    },

    updateEndpointForSourceAndMsn(endpoint) {
      const arr = []
      if (this.layersConf.hasOwnProperty('gs')) {
        Object.keys(this.layersConf.gs.groups).forEach((el) => arr.push(el))
      }
      if (this.layersConf.hasOwnProperty('msn')) {
        Object.keys(this.layersConf.msn.groups).forEach((el) => arr.push(el))
      }
      if (this.layers.some((el) => arr.includes(el))) {
        return endpoint.replace(/&\?year=?\d{4}/, '')
      }
      return endpoint
    },
    async setMapLayersData(conf, type) {
      this.$route.params.clustering_type =
        this.map._zoom <= MAP_MO
          ? 'mo'
          : this.map._zoom >= MAP_GRID
          ? ''
          : 'grid'
      this.$route.params.x_min = this.map.getBounds().getSouthWest().lng //  западная граница области отображения (долгота)
      this.$route.params.y_min = this.map.getBounds().getSouthWest().lat //  южная граница области (широта)
      this.$route.params.x_max = this.map.getBounds().getNorthEast().lng //  восточная граница (долгота)
      this.$route.params.y_max = this.map.getBounds().getNorthEast().lat //  северная граница (широта)
      this.$route.params.zoom = this.map._zoom
      this.$route.params.showZoom = true // для предотвращения удаления зума из запроса в методе serializeQuery

      if (type === 'msn') {
        this.$route.params.is_model = conf[type]?.groups.hasOwnProperty('model')
          ? null
          : 0 //  показывать модельные мсн 0 - без модельных, 1 - только модельные, null - все
        this.$route.params.empty1 = null
      } else if (type === 'gs') {
        if (!this.typesGarbage.length) {
          await this.getGarbageTypes()
        }
        this.$route.params.has_msn_rel = null
      }

      let endpoint = this.getLayerEndpoint(conf, type, this.$route)

      if (!endpoint) {
        return false
      }
      const prevRoute = urlUtil.encode(urlUtil.getPrevRoute(this.$route))

      endpoint += `?year=${this.$route.query.year || prevRoute?.query?.year}`

      endpoint = this.updateEndpointForSourceAndMsn(endpoint)
      endpoint = this.updateEndpointForLegalAndIndividual(endpoint)

      let data = this.$store.getters.readUrlEndpoint(endpoint)
      if (!data) {
        data = await (
          await this.$store.dispatch('updateUrlEndpoint', { endpoint })
        ).data
      }
      data = this.updateDataForLegalAndIndividual(data)
      if (type === 'transport') {
        this.mapLayers[type]._data = { 1: data }
      } else {
        this.mapLayers[type]._data = data
      }
    },
    async setDataToLayersFromStore() {
      let conf = this.getParentsConf(this.layers, this.getLayersConf())
      const legends = []
      for (let type in this.mapLayers) {
        if (!conf.hasOwnProperty(type)) {
          this.hideLayersByType(type)
          continue
        }
        await this.setMapLayersData(conf, type)
        const mapLayerType = this.mapLayers[type]
        if (this.yearChanged) {
          mapLayerType._geoJsonLayer.clearLayers()
          this.yearChanged = false
        }
        Object.keys(mapLayerType._layers).forEach((id) => {
          let subLayer = mapLayerType._layers[id]
          mapLayerType._geoJsonLayer.removeLayer(mapLayerType._layers[id])

          if (this.layers.indexOf(subLayer.checkbox) > -1) {
            if (!mapLayerType._layers[id]._data) {
              mapLayerType._layers[id]._data = mapLayerType._data[id] || []
            }
            mapLayerType.showLayer(id, this.clusterEnabled)
            if (this.layersWithData.indexOf(subLayer.checkbox) === -1) {
              this.layersWithData.push(subLayer.checkbox)
            }
          } else {
            mapLayerType.hideLayer(id, this.clusterEnabled)
            const layerWithDataIndex = this.layersWithData.indexOf(
              subLayer.checkbox
            )
            if (layerWithDataIndex !== -1) {
              this.layersWithData.splice(layerWithDataIndex, 1)
            }
          }
        })
      }
      const legendOptions = {
        name: 'Легенда',
        position: 'bottomleft',
        legend: legends,
      }
      if (
        this.legend &&
        this.legend._entries &&
        Object.values(this.legend._entries).length
      ) {
        for (let k in this.legend._entries) {
          this.legend.removeLegend(k)
        }
        this.legend.removeFrom(this.map)
        this.legend = null
      } else {
        this.legend = L.control.htmllegend(legendOptions)
        this.legend.addTo(this.map)
      }
    },
    hideLayersByType(type) {
      Object.keys(this.mapLayers[type]._layers).forEach((v) => {
        this.mapLayers[type].hideLayer(v)
      })
    },
    /* required for use in map-popup */
    popupIsOpened(markerInfo) {
      let usedRoute = url.getPrevOrCurrentRoute(this.$route)

      return usedRoute.query.openedPopupInfo === this.getMarkerHash(markerInfo)
    },
    /* required for use in map-popup */
    registerOpenPopup(markerInfo) {
      let openedPopupInfo = this.getMarkerHash(markerInfo)

      this.replaceRoute({ openedPopupInfo: openedPopupInfo })
    },
  },
}
